<template>
  <div id="app">
    <Loader />
    <router-view/>
  </div>
</template>
<script>
import Loader from "@/components/layout/utils/Loader";
export default {
  components: {Loader},
  async beforeMount() {
    await this.$store.dispatch(`refreshState`);
  },
  computed : {
    loading(){
      return this.$store.getters.getLoadingState;
    }
  },
}
</script>
<style lang="scss">
@import "assets/css/styles";
</style>
